export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8">有任何问题或建议？随时与我们取得联系</p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-400">bd@91yingshi.example.com</p>
            </div>
            <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className="ri-bug-line text-lg"></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">问题反馈</h3>
              <p className="text-xs text-foreground-400">feedback@91yingshi.example.com</p>
            </div>
            <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                <i className="ri-user-add-line text-lg"></i>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">内容投稿</h3>
              <p className="text-xs text-foreground-400">content@91yingshi.example.com</p>
            </div>
          </div>

          <p className="text-xs text-foreground-400">
            工作时间：周一至周五 9:00-18:00 · 我们会在24小时内回复您的邮件
          </p>
        </div>
      </div>
    </section>
  );
}